const About = () => {
    return (
        <h1>I am About Screen</h1>
    )
}

export default About;